import Autocomplete from '@mui/material/Autocomplete';

import { FormHelperText } from '@mui/material';
import { TextField } from '@mui/material';
import { useFetch } from '../../../../hooks/useFecth';

export default function SelectStoresCouponsLomadee({ value, name, onChange, placeholder, label, list }) {
    const { data, mutate, error, isFetching } = useFetch(`brokers/socialsoul/stores/coupons`);
    const options = data?.stores?.map(item => ({ id: item.id, label: `${item.name}`, ...item })) || [];
    const selected = options?.find(item => Number(value) === item.id) || null;
    
    return (
        <>
            <Autocomplete
                fullWidth
                placeholder={placeholder}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionKey={e => e.id}
                options={options}
                value={selected}
                name={name}
                loading={isFetching}
                onChange={(e, newValue) => onChange(newValue)}
                renderInput={params => <TextField {...params} label={placeholder || label} />}
            />
            {!!error?.message && <FormHelperText>{error?.message}</FormHelperText>}
        </>
    );
}
